import { getBranchRoles } from './session-util';
import * as UserType from '../constants/UserType'

const isItemDispenser = (item) => {
  return item.itemCategory == 'CE';
};

const getFrequencyOptions = (customerFrequency) => {
  return [1,2,4,6,8,12].filter(freq => freq % customerFrequency === 0).map(f => ('F' + f));
}

const itemSortMap = {
  OW: 1,
  CE: 2
};

const priceMap = {
  F1: 'f1Price',
  F2: 'f2Price',
  F4: 'f4Price',
  F6: 'f6Price',
  F8: 'f8Price',
  F12: 'f12Price'
};

const getRateForFrequency = (item, frequency, customerFrequency) => {
  if (!frequency.includes('F')) frequency = 'F' + frequency;

  const priceKey = priceMap[frequency] ?? priceMap['F' + customerFrequency];
  if (priceKey) return item[priceKey] * customerFrequency;

  return item.f1Price * customerFrequency;
};

const getFillItemNameById = (item, items) => {
  const fillItem = items.find((i) => i.id == item.fillItemId);

  if (fillItem) {
    return getFullItemName(fillItem);
  } else {
    return getFullItemName(item);
  }
};

const getFillItemDescById = (item, items) => {
  const fillItem = items.find((i) => i.id === item.fillItemId);
  return fillItem?.description ?? item.description;
};

const getFullItemName = (item) => {
  return `${item.itemCategory}${item.style}${item.color}${item.size}`;
};

const getProductCodeName = (item) => {
  return `${item.itemCategory}${item.style}${item.color}`;
};

const priceForItemFrequency = (item, frequency, customerFrequency) => {
  if (item.itemCategory == 'CE') {
    return { priceRental: getRateForFrequency(item, frequency, customerFrequency), priceReplace: item.replaceRate };
  }
  
  return { priceItem: getRateForFrequency(item, frequency, customerFrequency) };
};

const priceForItemPrice = (item, price, newPrice) => {
  if (item.itemCategory == 'CE') {
    return { ...price, priceRental: newPrice };
  }
  return { ...price, priceItem: newPrice };
};

const getItemFromOrder = (item, order, groupId = null) => {
  if (isItemDispenser(item) && groupId) {
    return order.lineItems.find(
      (i) => i.fillItemId == groupId && i.itemId == item.id
    );
  }
  // Not dispenser or not searching by group, so just find the matching item by id only
  return order.lineItems.find((i) => i.itemId == item.id);
};

const canApproveOrders = () => Object.values(getBranchRoles()).some((role) => UserType.GM === UserType[role] || UserType.RVP === UserType[role]);

export {
  isItemDispenser,
  getRateForFrequency,
  getFullItemName,
  getProductCodeName,
  getFrequencyOptions,
  priceForItemFrequency,
  priceForItemPrice,
  getItemFromOrder,
  canApproveOrders,
  getFillItemNameById,
  getFillItemDescById,
  itemSortMap
};
